import React, { useEffect, useState } from 'react';
import { CONSENT_KEY, hasDnt, loadGtm } from './gtm';

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (hasDnt()) return;
    const stored = window.localStorage.getItem(CONSENT_KEY);
    if (stored === null) {
      setVisible(true);
    }
  }, []);

  if (!visible) return null;

  const accept = () => {
    window.localStorage.setItem(CONSENT_KEY, 'true');
    window.__nbConsent = { analytics: true };
    setVisible(false);
    loadGtm();
  };

  const reject = () => {
    window.localStorage.setItem(CONSENT_KEY, 'false');
    window.__nbConsent = { analytics: false };
    setVisible(false);
  };

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 rounded-lg border border-gray-200 bg-white p-4 shadow-lg md:left-6 md:right-6 lg:left-auto lg:right-6 lg:max-w-lg">
      <div className="text-sm text-textColor">
        We use analytics cookies to understand site usage and improve the experience. You can accept
        or decline.
      </div>
      <div className="mt-3 flex gap-3">
        <button
          onClick={accept}
          className="rounded-full bg-brand px-4 py-2 text-sm font-semibold text-white"
        >
          Accept
        </button>
        <button
          onClick={reject}
          className="rounded-full border border-gray-300 px-4 py-2 text-sm font-semibold text-textColor"
        >
          Decline
        </button>
      </div>
    </div>
  );
}
